// extracted by css-extract-rspack-plugin
export default {"hybridTable":"vz2yU6JjIcbBynVx","column":"vDK0UjncZWQhwKHd","actionColumn":"R8KqYmK4JeAT0G1u"};